const actions = {
  SET_STATE: 'payments/SET_STATE',
  FETCH_ALL_PAYMENTS: 'payments/FETCH_ALL_PAYMENTS',
  FETCH_PAYMENTS_DETAILS: 'payments/FETCH_PAYMENTS_DETAILS',
}

export default actions
